module.exports = __webpack_public_path__ + "img/pr-13.18c624ca.png";